export const deepMapCopy = <T>(map: Map<string, T>): Map<string, T> => {
  const copy: Map<string, T> = new Map();
  for (const [key, value] of map.entries()) {
    if (Array.isArray(value)) {
      copy.set(key, [...value] as T);
    } else if (typeof value === 'object' && value !== null) {
      copy.set(key, { ...value } as T);
    } else {
      copy.set(key, value);
    }
  }
  return copy;
};

export const includesInObjectValues = (
  obj: Record<string, any>,
  searchString: string,
): boolean => {
  return Object.values(obj).some(value => {
    if (typeof value === 'string') {
      return value.toLowerCase().includes(searchString.toLowerCase());
    } else if (typeof value === 'object' && value !== null) {
      return includesInObjectValues(value, searchString);
    }
    return false;
  });
};

export const deepCopy = <T>(obj: T): T => JSON.parse(JSON.stringify(obj)) as T;

export const getValueByKey = <T>(
  obj: Record<string, any>,
  keyPath: string,
): T | undefined => {
  return keyPath.split('.').reduce((current: any, key: string) => {
    return current && current[key] !== undefined ? current[key] : undefined;
  }, obj);
};
